type Constructor<T> = { new(...args: any[]): T };

export type ComponentData = {}
export type ComponentType = Constructor<ComponentData>
type ComponentGroup = ComponentType[] | ComponentType
export type EntityId = number
export type Entity = { [key: string]: any }


function verifyComponents(components: ComponentGroup): boolean {

    if (!components || (Array.isArray(components) && components.length === 0)) {
        console.log("components are required for query")
        return false;
    }
    return true;
}

export function create<T extends ComponentData>(type: (new () => T), data: T): ComponentData {
    return Object.assign(new type(), data)
}

export class EntityManager {
    entities: Entity[];
    private tempEntityGroup: EntityGroup;
    private destroyGroup: EntityGroup;

    constructor() {

        this.tempEntityGroup = new EntityGroup(this);
        this.entities = [];
        this.destroyGroup = new EntityGroup(this, [IsDestroyed])
    }

    getFirst(components: ComponentGroup): Entity {
        if (!verifyComponents(components))
            return

        this.tempEntityGroup.components = Array.isArray(components) ? components : [components];
        this.tempEntityGroup.update();
        return this.tempEntityGroup.getEntity(0);
    }

    forEach(components: ComponentGroup, doAction: (Entity) => void): void {

        if (!verifyComponents(components))
            return

        try {

            this.tempEntityGroup.components = Array.isArray(components) ? components : [components];
            this.tempEntityGroup.update();
            this.tempEntityGroup.forEach(doAction);
        } catch (e) {
            console.log(e)
            debugger
        }
    }

    create(...components: ComponentData[]): Entity {
        const entity = <Entity>{};
        this.entities.push(entity);

        (components || []).forEach(c => {
            this.addComponent(entity, c)
        })

        return entity;
    }


    addComponent(entity: Entity, component: ComponentData): void {
        entity[component.constructor.name] = component
    }

    removeComponent(entity: Entity, component: ComponentData): void {
        delete entity[component.constructor.name]
    }


    /* applyDestroy():void {

         this.destroyGroup.update()

         if (this.destroyGroup.entityCount === 0)
             return

         const slice = this.destroyGroup.entityIdArray.slice(0, this.destroyGroup.entityCount)
         slice.sort()

         for (let i = this.destroyGroup.entityCount - 1; i >= 0; i--) {
             const entityId = this.destroyGroup.entityIdArray[i]
             this.entities[entityId] = this.entities[this.entities.length - 1]
             this.entities.pop()
         }

         this.destroyGroup.clear()
     }

     findById(id: EntityId) {

         return this.entities.find((e) => e.id === id)
     }*/
}


export class EntityGroup {
    components: ComponentType[];
    private entityManager: EntityManager;
    entityCount: number;
    entityIdArray: Uint32Array;


    constructor(entityManager: EntityManager, components: ComponentType[] = []) {
        this.entityManager = entityManager;
        this.entityCount = 0;
        this.entityIdArray = new Uint32Array(4096);
        this.components = components;
    }

    hasComponents(entity: Entity) {

        for (let i = 0; i < this.components.length; i++) {

            const c = entity[this.components[i].name]
            if (!c) {
                return false;
            }
        }

        return true;
    }

    add(entityId: EntityId): void {

        this.entityIdArray[this.entityCount] = entityId;
        this.entityCount++;
    }

    clear(): void {

        this.entityCount = 0;
    }

    update(): void {

        this.clear()

        for (let i = 0; i < this.entityManager.entities.length; i++) {

            let e = this.entityManager.entities[i];
            if (this.hasComponents(e)) {
                this.add(i)
            }
        }
        /*console.log("update",this.entityCount,"entities found",this.components)
        this.forEach((e)=>{
            console.log("entity",e,this.entityIdArray)
        })*/
    }

    getEntity(id: EntityId): Entity {
        return this.entityManager.entities[this.entityIdArray[id]];
    }

    forEach(doAction: (Entity) => void): void {
        for (let i = 0; i < this.entityCount; i++) {

            doAction(this.getEntity(i));
        }
    }
}

export class IsDestroyed implements ComponentData {

}